import styled from 'styled-components';

import { WarningFilled } from '@ant-design/icons';

export const Title = styled.div({
  marginTop: '20rem',
  maxHeight: '500rem',
});

export const Content = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&[data-type="remove"]': {
    justifyContent: 'space-between',
    width: '450rem',
  },
});

export const WarningTitle = styled.span(({ theme }) => ({
  lineHeight: '1',
  wordWrap: 'break-word',
  color: theme.palette.artichoke,
  fontFamily: theme.typography.family.playfairDisplay,
  textTransform: 'uppercase',
  fontSize: theme.typography.size24,
}));

export const WarningHeader = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  maxWidth: '520rem',
  fontFamily: theme.typography.family.arial,
  fontSize: theme.typography.size16,
  marginTop: '10rem',
  marginRight: '15rem',
}));

export const WarningIcon = styled(WarningFilled)(({ theme }) => ({
  color: theme.palette.meatBrown,
  fontSize: theme.typography.size24,
  marginRight: '10rem',
}));

export const RemoveContent = styled.div({
  width: '375rem',
});
